// LIBRERIE
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

//COMPONENTI
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";


// CONFIGURAZIONI
// import appConfig from "../../config/appConfig";

interface WorkingMethodProps {
    agencyId: number;
}

const WorkingMethod: React.FC<WorkingMethodProps> = ({ agencyId }) => {
    const { t } = useTranslation();
    const { loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

     const servicesList = t('servicesPage.section3List', { returnObjects: true }) as string[];

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>
            <Helmet>
                <title>{t('workingMethodPage.metaTitle')}</title>
                <meta name="description" content={t('workingMethodPage.metaDescription') as string }/>
            </Helmet>

            <SubHeaderDefault title={t('workingMethodPage.pageTitle')} isSeo={true} />

            <section className="space-pt mb-5">
                <div className="container-fluid">
                    
                    <h2 className="mb-5">{t('workingMethodPage.sectionTitle')}</h2>
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-8 mb-4 mb-lg-0">
                            <p dangerouslySetInnerHTML={{ __html: t('workingMethodPage.sectionText1') as string }}></p>
                            <p> {t('workingMethodPage.sectionText2')}</p>
                            <p> {t('workingMethodPage.sectionText3')}</p>
                            <p dangerouslySetInnerHTML={{ __html: t('workingMethodPage.sectionText4') as string }}></p>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div style={{
                                width: '100%',
                                height: '400px',
                                backgroundColor: '#ccc',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: '#fff',
                                fontSize: '2rem'
                            }}>
                                <img src="/assets/images/agenzia/ceccarelli_2.jpg" className="border-img" style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Ceccarelli" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="space-pb service-list-section">
                <div className="container">
                    <h2 className="mb-5">{t('servicesPage.section3Title')}</h2>
                    <div className="row align-items-start">
                        <div className="col-12">
                            <p>{t('servicesPage.section3Text1')}</p>
                            <ul>
                                { servicesList.map((service, index) => (
                                    <li key={index} className="mb-2" dangerouslySetInnerHTML={{ __html: service as string }}></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default WorkingMethod;
